import React, { useState } from 'react';

const RiyaTravelSupplierHighlight = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [billingCycle, setBillingCycle] = useState(1); // 1 = Monthly, 2 = Annually

  // Company Information - Zotrai (YOUR COMPANY)
  const companyInfo = {
    name: "Zotrai",
    themeColor: "#FF7F00",
    description: "Your trusted B2B travel technology partner",
    founded: "2020",
    headquarters: "India",
    agents: "10,000+",
    suppliers: "50+",
    countries: "100+",
    uptime: "99.9%",
    apiCalls: "100M+",
    team: "100+",
    email: "support@zotrai.com",
    phone: "+91-7207642485"
  };

// Why Suppliers Choose Zotrai - REAL DATA
  const whyZotraiData = {
    benefits: [
        {
        id: 1,
        title: "Single API Integration, Multiple Connections",
        description: "Connect once with Zotrai and get instant access to all our partner suppliers - no multiple integrations needed",
        icon: "ri-plug-line",
        stat: "1",
        statLabel: "Integration"
      },
     {
  id: 2,
  title: "Launch B2B, B2C & Corporate Portals",
  description: "Fully customizable multi-agent, direct-sell, and corporate booking platforms under your brand",
  icon: "ri-window-line",
  stat: "All-in-One",
  statLabel: "Portal Suite"
},
    
      {
  id: 3,
  title: "Save 95% on Integration Costs",
  description: "No setup fees, no integration charges.",
icon: "ri-coins-line",

  stat: "95%",
  statLabel: "Cost Savings"
},
      {
        id: 4,
        title: "Real-time Analytics Dashboard",
        description: "Track your inventory performance, booking patterns, and agent behavior with detailed analytics",
        icon: "ri-bar-chart-2-line",
        stat: "24/7",
        statLabel: "Monitoring"
      },
      {
        id: 5,
        title: "99.9% Uptime Guarantee",
        description: "Enterprise-grade infrastructure with redundant systems ensuring your APIs are always available",
        icon: "ri-shield-check-line",
        stat: "99.9%",
        statLabel: "Uptime"
      },
      {
        id: 6,
        title: "Dedicated Account Manager",
        description: "Every supplier gets a dedicated technical account manager for seamless integration and support",
        icon: "ri-customer-service-line",
        stat: "24/7",
        statLabel: "Support"
      }
    ],
    process: [
      {
        step: 1,
        title: "Add Your API Credentials",
        description: "Just Login, paste your API keys, and we handle the rest – zero development effort"
      },
       {
        step: 2,
        title: "Select & Customize Template",
        description: "Pick from our library of 100+ responsive templates and match your brand identity"
      },
      {
        step: 3,
        title: "Go Live Instantly",
        description: "Deploy to production in one click and start accepting real bookings"
      }
    ]
  };

  // SEO-friendly structured data for Riya Travel
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Riya Travel",
    "description": "Premium travel supplier offering curated holiday experiences and luxury travel packages worldwide",
    "url": "https://www.riyatravel.com",
    "areaServed": "Worldwide",
    "serviceType": ["Luxury Travel", "Custom Itineraries", "VIP Services", "Corporate Travel"],
    "foundingDate": "1985",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Dubai",
      "addressCountry": "UAE"
    }
  };

  // Riya Travel specific data
  const riyaData = {
    name: "Riya Travel",
    description: "Premium travel supplier offering curated holiday experiences and luxury travel packages worldwide. Known for personalized service and exclusive deals.",
    longDescription: "Riya Travel has been a distinguished name in the travel industry since 1985, specializing in premium and luxury travel experiences. With headquarters in Dubai and a strong presence across the Middle East, Riya Travel has built a reputation for excellence in personalized service, exclusive access to luxury properties, and meticulously curated itineraries. The company caters to discerning travelers seeking unique experiences, from private jet charters and luxury cruises to bespoke cultural tours and VIP event access. Riya Travel's team of experienced travel consultants works closely with clients to create tailor-made journeys that exceed expectations, leveraging their extensive network of premium suppliers and local partners worldwide. Their commitment to quality and attention to detail has made them the preferred choice for luxury travel agents and corporate clients seeking unparalleled travel experiences.",
    founded: "1985",
    headquarters: "Dubai, UAE",
    employees: "500+",
    branches: "25+",
    countries: "100+",
    luxuryHotels: "150,000+",
    airlines: "200+",
    cruises: "500+",
    privateJets: "50+",
    vipServices: "24/7 Concierge",
    agents: "2,500+",
    themeColor: "#9C27B0", // Premium Purple color
    website: "https://www.riyatravel.com",
    apiType: "RESTful API",
    integrationType: "Direct API Integration",
    support: "24/7 VIP Concierge Support"
  };

  // Key features of Riya Travel
  const features = [
    {
      icon: "👑",
      title: "150,000+ Luxury Hotels",
      description: "Curated collection of world's finest luxury hotels, resorts, and private villas"
    },
    {
      icon: "✈️",
      title: "Private Jet Charters",
      description: "Exclusive access to private jet fleets for discerning travelers"
    },
    {
      icon: "🛳️",
      title: "Luxury Cruises",
      description: "Premium cruise experiences on world's most luxurious cruise lines"
    },
    {
      icon: "🎯",
      title: "Bespoke Itineraries",
      description: "Custom-crafted travel experiences tailored to individual preferences"
    }
  ];

  // Services offered by Riya Travel
  const services = [
    {
      id: 1,
      title: "Luxury Hotel Booking API",
      description: "Access to 150,000+ premium hotels, resorts, and private villas worldwide with exclusive VIP amenities.",
      features: [
        "5-star luxury properties",
        "VIP amenities & upgrades",
        "Early check-in/late checkout",
        "Personal concierge access",
        "Exclusive rate programs",
        "Verified reviews"
      ],
      icon: "👑"
    },
    {
      id: 2,
      title: "Private Jet Charter",
      description: "Exclusive access to private jet fleets for seamless luxury travel experiences.",
      features: [
        "Global charter network",
        "VIP terminals",
        "Customized catering",
        "Ground transportation",
        "24/7 flight support",
        "Multi-leg itineraries"
      ],
      icon: "🛩️"
    },
    {
      id: 3,
      title: "Luxury Cruise Booking",
      description: "Premium cruise experiences on world's most luxurious cruise lines with exclusive amenities.",
      features: [
        "Luxury cruise lines",
        "Suite categories",
        "All-inclusive packages",
        "Shore excursions",
        "Onboard credits",
        "Special occasion packages"
      ],
      icon: "🛳️"
    },
    {
      id: 4,
      title: "VIP Concierge Services",
      description: "24/7 dedicated concierge service for personalized travel assistance and exclusive access.",
      features: [
        "Restaurant reservations",
        "Event tickets",
        "Spa bookings",
        "Private guides",
        "Airport VIP services",
        "Special requests"
      ],
      icon: "🎩"
    },
    {
      id: 5,
      title: "Corporate Travel Management",
      description: "Comprehensive corporate travel solutions for executives and business leaders.",
      features: [
        "Executive travel",
        "Corporate rates",
        "Travel policy compliance",
        "Expense management",
        "Management reports",
        "24/7 support"
      ],
      icon: "💼"
    },
    {
      id: 6,
      title: "Bespoke Tour Packages",
      description: "Custom-crafted luxury tour packages with private guides and exclusive experiences.",
      features: [
        "Private guides",
        "Luxury transportation",
        "Fine dining experiences",
        "Cultural immersion",
        "Photography tours",
        "Wine tasting experiences"
      ],
      icon: "🌍"
    }
  ];

  // Technology highlights
  const technology = [
    {
      title: "RESTful APIs",
      description: "Modern RESTful API architecture with comprehensive documentation"
    },
    {
      title: "Real-time Availability",
      description: "Live inventory updates from luxury properties worldwide"
    },
    {
      title: "VIP Rate Access",
      description: "Exclusive access to unpublished VIP rates and amenities"
    },
    {
      title: "Multi-currency Support",
      description: "Transactions in major global currencies with dynamic conversion"
    },
    {
      title: "Secure Payments",
      description: "PCI compliant with encrypted data transmission"
    },
    {
      title: "Concierge Integration",
      description: "Seamless integration with VIP concierge services"
    }
  ];

  // Integration process
  const integrationProcess = [
    {
      step: 1,
      title: "API Documentation",
      description: "Receive comprehensive API docs and VIP rate access credentials"
    },
    {
      step: 2,
      title: "Sandbox Testing",
      description: "Test integration in Riya Travel's staging environment"
    },
    {
      step: 3,
      title: "Go Live",
      description: "Deploy to production with 24/7 VIP concierge support"
    }
  ];

  // Why choose Riya Travel
  const whyChoose = [
    "Established 1985 • 35+ years of luxury travel expertise",
    "150,000+ premium luxury properties worldwide",
    "Exclusive VIP rates and amenities",
    "Private jet and luxury cruise specialists",
    "24/7 dedicated concierge service",
    "Preferred partner for leading luxury hotel brands"
  ];

  // Supplier logos array with navigation paths
  const suppliers = [
    { 
      id: 1, 
      name: "Tripjack", 
      logo: "/assets/images/suppliers/tripjack.png",
      path: "/supplier/trip-jack"
    },
    { 
      id: 2, 
      name: "TBO", 
      logo: "/assets/images/suppliers/tbo.png",
      path: "/supplier/tbo"
    },
    { 
      id: 3, 
      name: "Akbar Travels", 
      logo: "/assets/images/suppliers/akbar.png",
      path: "/supplier/akbar-travels"
    },
    { 
      id: 4, 
      name: "RezLive", 
      logo: "/assets/images/suppliers/rezlive.png",
      path: "/supplier/rezlive"
    },
    { 
      id: 5, 
      name: "GRN Connect", 
      logo: "/assets/images/suppliers/grn.png",
      path: "/supplier/grn-connect"
    },
    { 
      id: 6, 
      name: "Riya Travel", 
      logo: "/assets/images/suppliers/riya.png",
      path: "/supplier/riya-travel"
    },
    { 
      id: 7, 
      name: "Viator", 
      logo: "/assets/images/suppliers/viator.png",
      path: "/supplier/viator"
    },
    { 
      id: 8, 
      name: "Air iQ", 
      logo: "/assets/images/suppliers/airiq.png",
      path: "/supplier/air-iq"
    }
  ];

  // Pricing plans data
  const plans = [
    {
      id: 1,
      name: "Starter",
      description: "🚀 All-in-one powerful plan with complete access to every feature.",
      monthly: 2999,
      annually: 29999,
      popular: true,
      emoji: "🚀",
      features: [
        "Search, compare, and book flights from top global suppliers in one place",
        "Access and connect with 1,000+ verified global DMCs",
        "Smart accounting suite with ledgers, invoices, supplier settlements, and corporate payments",
        "Capture leads directly from social media and run promotions from a single dashboard",
        "Generate professional itineraries in minutes using AI",
        "AI-powered visa processing and document management system",
        "One unified platform for Flights, Hotels, Visas, Cars, Sightseeing, and more",
        "Integrated and secure payment gateway",
        "Plug in and manage your own supplier APIs seamlessly",
        "AI-based WhatsApp automation for leads, follow-ups, and customer support",
        "Unlimited email marketing and promotional campaigns",
        "Advanced reports and analytics for sales, revenue, and performance tracking",
      ],
      addons: [
        "Launch your own B2C booking website for customers in minutes – just INR 999",
        "Launch a full-featured B2C travel portal with flights, hotels, and packages using your preferred suppliers – INR 1,999",
        "Launch a B2B travel portal for your agent network with flights, hotels, and packages – INR 1,999",
        "Launch a B2E corporate travel portal for your business clients with flights, hotels, and packages – INR 1,999",
      ],
    },
  ];

  const getAccentColor = (planName) => {
    if (planName === "Starter") return "#10B981";
    if (planName === "Pro") return "#3B82F6";
    return "#8B5CF6";
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${companyInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo.phone.replace(/[^0-9+]/g, '')}`;
  };

  const handleSupplierClick = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Riya Travel - Premium Luxury Travel Supplier | Zotrai</title>
        <meta name="description" content="Riya Travel is a premier luxury travel supplier offering 150,000+ luxury hotels, private jet charters, and VIP concierge services through Zotrai integration." />
        <meta name="keywords" content="Riya Travel, luxury travel, private jet, luxury cruises, VIP concierge, bespoke travel, corporate travel" />
        <link rel="canonical" href="https://yourcompany.com/supplier/riya-travel" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Riya Travel - Premium Luxury Travel Supplier" />
        <meta property="og:description" content="Connect with Riya Travel's exclusive network of 150,000+ luxury properties and VIP services through Zotrai's single API integration." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Main Content with riya- prefix */}
      <div className="riya-supplier-container">
        {/* Header Section - Riya Travel Hero */}
        <header className="riya-header">
          <div className="riya-container">
            <h1 className="riya-title">
              <span className="riya-highlight" style={{ color: riyaData.themeColor }}>Riya Travel</span>
              <br />
              Premium Luxury Travel Since 1985
            </h1>
            <p className="riya-subtitle">
              {riyaData.description}
            </p>
          </div>
        </header>

        {/* Tabs Navigation - Same as others */}
        <div className="riya-tabs-container">
          <div className="riya-container">
            <div className="riya-tabs">
              <button 
                className={`riya-tab ${activeTab === 'about' ? 'riya-tab-active' : ''}`}
                onClick={() => setActiveTab('about')}
              >
                About
              </button>
              <button 
                className={`riya-tab ${activeTab === 'services' ? 'riya-tab-active' : ''}`}
                onClick={() => setActiveTab('services')}
              >
                Services
              </button>
              <button 
                className={`riya-tab ${activeTab === 'technology' ? 'riya-tab-active' : ''}`}
                onClick={() => setActiveTab('technology')}
              >
                Technology
              </button>
              <button 
                className={`riya-tab ${activeTab === 'whyzotrai' ? 'riya-tab-active' : ''}`}
                onClick={() => setActiveTab('whyzotrai')}
              >
                Why Zotrai <span className="riya-tab-badge">For Suppliers</span>
              </button>
              <button 
                className={`riya-tab ${activeTab === 'suppliers' ? 'riya-tab-active' : ''}`}
                onClick={() => setActiveTab('suppliers')}
              >
                Suppliers
              </button>
              <button 
                className={`riya-tab ${activeTab === 'pricing' ? 'riya-tab-active' : ''}`}
                onClick={() => setActiveTab('pricing')}
              >
                Pricing
              </button>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="riya-tab-content">
          {activeTab === 'about' && (
            <section className="riya-about">
              <div className="riya-container">
                <div className="riya-grid">
                  <div className="riya-about-content">
                    <h2 className="riya-section-title">About <span className="riya-accent" style={{ color: riyaData.themeColor }}>Riya Travel</span></h2>
                    <p className="riya-text">
                      {riyaData.longDescription}
                    </p>
                    
                    <div className="riya-features">
                      {features.map((feature, index) => (
                        <div key={index} className="riya-feature">
                          <span className="riya-feature-icon">{feature.icon}</span>
                          <div>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="riya-card">
                    <h3 className="riya-card-title">Riya Travel at a Glance</h3>
                    <ul className="riya-list">
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        Established 1985 • 35+ Years of Excellence
                      </li>
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        150,000+ Luxury Hotels & Resorts
                      </li>
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        200+ Premium Airlines
                      </li>
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        500+ Luxury Cruises
                      </li>
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        50+ Private Jet Partners
                      </li>
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        100+ Countries Covered
                      </li>
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        24/7 VIP Concierge Service
                      </li>
                      <li className="riya-list-item">
                        <span className="riya-check" style={{ color: riyaData.themeColor }}>✓</span>
                        Exclusive VIP Rates & Amenities
                      </li>
                    </ul>

                    <h3 className="riya-card-title riya-mt-4">Luxury Partners</h3>
                    <div className="riya-partner-tags">
                      <span className="riya-partner-tag">Four Seasons</span>
                      <span className="riya-partner-tag">Ritz-Carlton</span>
                      <span className="riya-partner-tag">Mandarin Oriental</span>
                      <span className="riya-partner-tag">Aman</span>
                      <span className="riya-partner-tag">Belmond</span>
                      <span className="riya-partner-tag">Oetker Collection</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'services' && (
            <section className="riya-services">
              <div className="riya-container">
                <h2 className="riya-section-title riya-text-center">
                  Premium Luxury Travel Solutions
                </h2>
                <p className="riya-section-subtitle">
                  Through our integration with Riya Travel, we deliver exclusive luxury travel experiences
                </p>

                <div className="riya-services-grid">
                  {services.map((service) => (
                    <div key={service.id} className="riya-service-card">
                      <div className="riya-service-icon">{service.icon}</div>
                      <h3 className="riya-service-title">{service.title}</h3>
                      <p className="riya-service-description">{service.description}</p>
                      <ul className="riya-service-list">
                        {service.features.map((feature, index) => (
                          <li key={index} className="riya-service-list-item">
                            <span className="riya-dot" style={{ color: riyaData.themeColor }}>•</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeTab === 'technology' && (
            <section className="riya-technology">
              <div className="riya-container">
                <div className="riya-grid">
                  <div className="riya-integration-box">
                    <h3 className="riya-card-title">Seamless Integration</h3>
                    <p className="riya-text">
                      Our integration with Riya Travel's robust APIs ensures smooth data flow, real-time availability of luxury inventory, and reliable performance for premium travel bookings.
                    </p>
                    <div className="riya-tags">
                      {technology.map((tech, index) => (
                        <span key={index} className="riya-tag">{tech.title}</span>
                      ))}
                    </div>
                  </div>

                  <div className="riya-benefits-box">
                    <h3 className="riya-card-title">Key Advantages</h3>
                    <ul className="riya-benefits-list">
                      <li className="riya-benefits-item">
                        <span className="riya-benefits-icon">⚡</span>
                        Lightning-fast API response times
                      </li>
                      <li className="riya-benefits-item">
                        <span className="riya-benefits-icon">🛡️</span>
                        Enterprise-grade security protocols
                      </li>
                      <li className="riya-benefits-item">
                        <span className="riya-benefits-icon">🎧</span>
                        VIP concierge support
                      </li>
                      <li className="riya-benefits-item">
                        <span className="riya-benefits-icon">👥</span>
                        Experienced luxury travel team
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'whyzotrai' && (
            <section className="riya-why-zotrai-section">
              <div className="riya-container">
                {/* Header */}
                <div className="riya-why-header">
                  <span className="riya-why-badge" style={{ background: `${companyInfo.themeColor}15`, color: companyInfo.themeColor }}>
                    <i className="ri-question-line"></i> WHY SUPPLIERS CHOOSE ZOTRAI
                  </span>
                  <h2 className="riya-section-title">
                    Your Growth Partner in <span className="riya-accent" style={{ color: companyInfo.themeColor }}>Travel Distribution</span>
                  </h2>
                  <p className="riya-section-subtitle">
                    Join 50+ leading travel suppliers who trust us to connect them with travel agents
                  </p>
                </div>

                {/* Benefits Grid */}
                <div className="riya-benefits-grid-full">
                  {whyZotraiData.benefits.map((benefit) => (
                    <div key={benefit.id} className="riya-benefit-card">
                      <div className="riya-benefit-icon-wrapper" style={{ background: `${companyInfo.themeColor}15` }}>
                        <i className={benefit.icon} style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="riya-benefit-content">
                        <h3>{benefit.title}</h3>
                        <p>{benefit.description}</p>
                        <div className="riya-benefit-stat">
                          <span className="riya-stat-highlight" style={{ color: companyInfo.themeColor }}>{benefit.stat}</span>
                          <span className="riya-stat-label">{benefit.statLabel}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Integration Process */}
                <div className="riya-integration-process">
                  <h3 className="riya-process-title">Simple 3-Step Integration</h3>
                  <div className="riya-process-steps">
                    {whyZotraiData.process.map((step) => (
                      <div key={step.step} className="riya-process-step">
                        <div className="riya-step-number" style={{ background: companyInfo.themeColor }}>{step.step}</div>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Section */}
                <div className="riya-contact-section">
                  <h3>Ready to Join Our Supplier Network?</h3>
                  <p>Connect with agents through a single integration</p>
                  
                  <div className="riya-contact-info">
                    <div className="riya-contact-item" onClick={handleEmailClick}>
                      <div className="riya-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-mail-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="riya-contact-details">
                        <span className="riya-contact-label">Email Support</span>
                        <span className="riya-contact-value">{companyInfo.email}</span>
                      </div>
                    </div>

                    <div className="riya-contact-item" onClick={handlePhoneClick}>
                      <div className="riya-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-phone-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="riya-contact-details">
                        <span className="riya-contact-label">Phone Support</span>
                        <span className="riya-contact-value">{companyInfo.phone}</span>
                      </div>
                    </div>
                  </div>

                  <p className="riya-contact-note">
                    Our support team is available 24/7 to assist you with any questions
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'suppliers' && (
            <section className="riya-suppliers-section">
              <div className="riya-container">
                {/* Section Header */}
                <div className="riya-suppliers-header">
                  <span className="riya-suppliers-badge">
                    <i className="ri-handshake-line"></i> OUR INTEGRATED SUPPLIERS
                  </span>
                  <h2 className="riya-section-title">
                    Connect With <span className="riya-accent">Leading Travel Suppliers</span>
                  </h2>
                  <p className="riya-section-subtitle">
                    Direct integrations with industry-leading travel suppliers worldwide
                  </p>
                </div>

                {/* Clickable Logo Grid */}
                <div className="riya-logo-grid">
                  {suppliers.map((supplier) => (
                    <div 
                      key={supplier.id} 
                      className="riya-logo-item riya-clickable"
                      onClick={() => handleSupplierClick(supplier.path)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSupplierClick(supplier.path);
                        }
                      }}
                    >
                      <div className="riya-logo-wrapper">
                        <img 
                          src={supplier.logo} 
                          alt={supplier.name}
                          className="riya-supplier-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://via.placeholder.com/80x40?text=${supplier.name.charAt(0)}`;
                          }}
                        />
                      </div>
                      <span className="riya-logo-name">{supplier.name}</span>
                      <span className="riya-view-details-hint">
                        View Details <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  ))}
                </div>

                {/* Simple Stats */}
                <div className="riya-supplier-stats-simple">
                  
                  <div className="riya-stat-simple">
                    <span className="riya-stat-number">1M+</span>
                    <span className="riya-stat-label">Hotel Properties</span>
                  </div>
                  <div className="riya-stat-simple">
                    <span className="riya-stat-number">80+</span>
                    <span className="riya-stat-label">Airlines</span>
                  </div>
                  <div className="riya-stat-simple">
                    <span className="riya-stat-number">300K+</span>
                    <span className="riya-stat-label">Activities</span>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'pricing' && (
            <section className="riya-pricing-section">
              <div className="riya-container">
                <div className="riya-pricing-header">
                  <h2 className="riya-section-title riya-text-center">
                    Plans & <span className="riya-accent">Pricing</span>
                  </h2>
                  <p className="riya-section-subtitle">
                    Pick the plan that's right for your business growth
                  </p>
                  
                  {/* Billing Toggle */}
                  <div className="riya-billing-toggle">
                    <button
                      className={`riya-toggle-btn ${billingCycle === 1 ? 'riya-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(1)}
                    >
                      Monthly
                    </button>
                    <button
                      className={`riya-toggle-btn ${billingCycle === 2 ? 'riya-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(2)}
                    >
                      Annually
                      <span className="riya-save-badge">Save 20%</span>
                    </button>
                  </div>
                </div>

                {/* Pricing Cards */}
                <div className="riya-pricing-grid">
                  {plans.map((plan) => {
                    const isMonthly = billingCycle === 1;
                    const accentColor = getAccentColor(plan.name);
                    
                    return (
                      <div key={plan.id} className="riya-pricing-card-enhanced">
                        {plan.popular && (
                          <div className="riya-popular-badge">
                            ⭐ MOST POPULAR
                          </div>
                        )}

                        <div className="riya-pricing-card-content">
                          {/* Pricing Side */}
                          <div className="riya-pricing-left" style={{ backgroundColor: plan.popular ? '#F4F9FF' : '#ffffff' }}>
                            <div className="riya-pricing-emoji">{plan.emoji}</div>
                            <h3 className="riya-pricing-name">{plan.name}</h3>
                            <p className="riya-pricing-description">{plan.description}</p>

                            <div className="riya-pricing-amount">
                              <span className="riya-currency">INR</span>
                              <span className="riya-price">
                                {isMonthly ? plan.monthly.toLocaleString() : plan.annually.toLocaleString()}
                              </span>
                              <span className="riya-pricing-period">
                                /{isMonthly ? 'month' : 'year'}
                              </span>
                            </div>

                            <button 
                              className="riya-pricing-cta"
                              style={{ backgroundColor: accentColor }}
                              onClick={() => window.location.href = '/signup'}
                            >
                              Start Free Trial <i className="ri-arrow-right-line"></i>
                            </button>

                            {/* Quick 3-Step Setup */}
                            <div className="riya-quick-setup">
                              <h4 className="riya-setup-title">Quick 3-Step Setup</h4>
                              <div className="riya-setup-steps">
                                <div className="riya-setup-step">
                                  <div className="riya-step-marker" style={{ background: accentColor }}>1</div>
                                  <div className="riya-step-content">
                                    <strong>Sign Up & Choose Plan</strong>
                                    <span>Create your account in 30 seconds - no credit card required</span>
                                  </div>
                                </div>
                                <div className="riya-setup-step">
                                  <div className="riya-step-marker" style={{ background: accentColor }}>2</div>
                                  <div className="riya-step-content">
                                    <strong>Select Your Suppliers</strong>
                                    <span>Choose from leading travel suppliers with one click</span>
                                  </div>
                                </div>
                                <div className="riya-setup-step">
                                  <div className="riya-step-marker" style={{ background: accentColor }}>3</div>
                                  <div className="riya-step-content">
                                    <strong>Launch Your Portal</strong>
                                    <span>Go live with your branded website in minutes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Features Side */}
                          <div className="riya-pricing-right">
                            <h5 className="riya-features-title" style={{ color: accentColor }}>
                              Included in {plan.name}
                            </h5>
                            
                            <div className="riya-features-list">
                              {plan.features.map((feature, index) => (
                                <div key={index} className="riya-feature-item">
                                  <div className="riya-feature-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-check-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{feature}</span>
                                </div>
                              ))}
                            </div>

                            <h5 className="riya-features-title riya-addons-title" style={{ color: accentColor }}>
                              Add-Ons
                            </h5>
                            
                            <div className="riya-addons-list">
                              {plan.addons.map((addon, index) => (
                                <div key={index} className="riya-addon-item">
                                  <div className="riya-addon-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-add-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{addon}</span>
                                </div>
                              ))}
                            </div>

                            <div className="riya-pricing-footer">
                              <span>✓ Transparent pricing, no hidden fees</span>
                              <span className="riya-support-link" style={{ color: accentColor }}>
                                Need help? Chat with us
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      {/* Styles with riya- prefix */}
      <style jsx>{`
        .riya-supplier-container {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
          line-height: 1.6;
          color: #1e293b;
        }

        .riya-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Header Styles */
        .riya-header {
          background: #ffffff;
          color: #1e293b;
          padding: 80px 0 40px;
          text-align: center;
        }

        .riya-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin: 0 0 15px;
          line-height: 1.2;
          color: #1e293b;
        }

        .riya-highlight {
          font-size: 4rem;
          display: inline-block;
          font-weight: 800;
        }

        .riya-subtitle {
          font-size: 1.25rem;
          max-width: 700px;
          margin: 0 auto;
          color: #475569;
        }

        /* Tabs Navigation */
        .riya-tabs-container {
          background: #ffffff;
          border-bottom: 2px solid #e2e8f0;
          margin-bottom: 40px;
          position: sticky;
          top: 0;
          z-index: 100;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }

        .riya-tabs {
          display: flex;
          gap: 30px;
          overflow-x: auto;
          padding: 0 24px;
        }

        .riya-tab {
          background: none;
          border: none;
          padding: 16px 0;
          font-size: 1rem;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          position: relative;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .riya-tab:hover {
          color: #0f172a;
        }

        .riya-tab-active {
          color: #0f172a;
        }

        .riya-tab-active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: ${riyaData.themeColor};
        }

        .riya-tab-badge {
          background: ${riyaData.themeColor};
          color: white;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 500;
        }

        /* About Section */
        .riya-about {
          padding: 40px 0 60px;
          background: #ffffff;
        }

        .riya-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          align-items: start;
        }

        .riya-section-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .riya-text-center {
          text-align: center;
        }

        .riya-accent {
          position: relative;
          display: inline-block;
        }

        .riya-accent::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 4px;
          background: ${riyaData.themeColor};
          border-radius: 2px;
        }

        .riya-text {
          font-size: 1.1rem;
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.8;
        }

        .riya-features {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-top: 30px;
        }

        .riya-feature {
          display: flex;
          gap: 15px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .riya-feature:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          border-color: ${riyaData.themeColor};
        }

        .riya-feature-icon {
          font-size: 2rem;
          min-width: 50px;
        }

        .riya-feature h4 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 5px;
          color: #0f172a;
        }

        .riya-feature p {
          font-size: 0.95rem;
          color: #475569;
          margin: 0;
        }

        .riya-card {
          background: white;
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
        }

        .riya-card-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .riya-mt-4 {
          margin-top: 30px;
        }

        .riya-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .riya-list-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          font-size: 1rem;
          color: #334155;
        }

        .riya-check {
          font-weight: bold;
          font-size: 1.2rem;
        }

        .riya-partner-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .riya-partner-tag {
          background: #f1f5f9;
          color: #334155;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 500;
          border: 1px solid #e2e8f0;
        }

        /* Services Section */
        .riya-services {
          padding: 40px 0 60px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .riya-section-subtitle {
          font-size: 1.25rem;
          color: #475569;
          text-align: center;
          max-width: 700px;
          margin: 0 auto 50px;
        }

        .riya-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .riya-service-card {
          background: white;
          padding: 35px 25px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
        }

        .riya-service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: ${riyaData.themeColor};
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .riya-service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(156, 39, 176, 0.1);
        }

        .riya-service-card:hover::before {
          transform: scaleX(1);
        }

        .riya-service-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .riya-service-title {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .riya-service-description {
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .riya-service-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .riya-service-list-item {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          color: #475569;
          font-size: 0.95rem;
        }

        .riya-dot {
          font-weight: bold;
        }

        /* Technology Section */
        .riya-technology {
          padding: 40px 0 60px;
          background: white;
        }

        .riya-integration-box,
        .riya-benefits-box {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 40px;
          border-radius: 24px;
          border: 1px solid #eef2f6;
        }

        .riya-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 25px;
        }

        .riya-tag {
          background: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-size: 0.9rem;
          color: ${riyaData.themeColor};
          font-weight: 500;
          border: 1px solid ${riyaData.themeColor}30;
          transition: all 0.3s ease;
        }

        .riya-tag:hover {
          background: ${riyaData.themeColor};
          color: white;
          border-color: ${riyaData.themeColor};
          transform: scale(1.05);
        }

        .riya-benefits-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .riya-benefits-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          font-size: 1.1rem;
          color: #1e293b;
        }

        .riya-benefits-icon {
          font-size: 1.5rem;
          background: white;
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        /* Why Zotrai Section */
        .riya-why-zotrai-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .riya-why-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .riya-why-badge {
          display: inline-block;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
        }

        .riya-benefits-grid-full {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          margin-bottom: 50px;
        }

        .riya-benefit-card {
          display: flex;
          gap: 20px;
          background: #f8fafc;
          padding: 25px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
        }

        .riya-benefit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.05);
          border-color: ${companyInfo.themeColor};
        }

        .riya-benefit-icon-wrapper {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .riya-benefit-icon-wrapper i {
          font-size: 2rem;
        }

        .riya-benefit-content h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        .riya-benefit-content p {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 12px;
          line-height: 1.6;
        }

        .riya-benefit-stat {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .riya-stat-highlight {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .riya-integration-process {
          text-align: center;
          margin: 60px 0;
        }

        .riya-process-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #0f172a;
        }

        .riya-process-steps {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .riya-process-step {
          text-align: center;
          padding: 30px;
          background: #f8fafc;
          border-radius: 20px;
          border: 1px solid #eef2f6;
        }

        .riya-process-step .riya-step-number {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 auto 20px;
        }

        /* Contact Section */
        .riya-contact-section {
          background: #ffffff;
          padding: 60px;
          border-radius: 30px;
          text-align: center;
          color: #0f172a;
          margin-top: 60px;
          border: 2px solid #eef2f6;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .riya-contact-section h3 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .riya-contact-section p {
          font-size: 1.2rem;
          color: #475569;
          margin-bottom: 40px;
        }

        .riya-contact-info {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .riya-contact-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 20px 30px;
          background: #f8fafc;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 280px;
        }

        .riya-contact-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-color: ${companyInfo.themeColor};
        }

        .riya-contact-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .riya-contact-icon i {
          font-size: 1.8rem;
        }

        .riya-contact-details {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .riya-contact-label {
          font-size: 0.85rem;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .riya-contact-value {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0f172a;
        }

        .riya-contact-note {
          font-size: 0.95rem !important;
          color: #64748b !important;
          margin-top: 20px;
          margin-bottom: 0 !important;
        }

        /* Suppliers Section */
        .riya-suppliers-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .riya-suppliers-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .riya-suppliers-badge {
          display: inline-block;
          background: linear-gradient(135deg, #2563eb15, #7c3aed15);
          color: #2563eb;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
          border: 1px solid #2563eb20;
        }

        .riya-suppliers-badge i {
          margin-right: 8px;
        }

        .riya-logo-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-bottom: 50px;
        }

        .riya-logo-item {
          text-align: center;
          padding: 20px;
          background: white;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .riya-logo-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(37, 99, 235, 0.15);
          border-color: #2563eb;
        }

        .riya-logo-item:hover .riya-view-details-hint {
          opacity: 1;
          transform: translateY(0);
        }

        .riya-logo-wrapper {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 15px;
        }

        .riya-supplier-logo {
          max-width: 120px;
          max-height: 60px;
          object-fit: contain;
          transition: transform 0.3s ease;
        }

        .riya-logo-item:hover .riya-supplier-logo {
          transform: scale(1.05);
        }

        .riya-logo-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 5px;
        }

        .riya-view-details-hint {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          color: #2563eb;
          font-weight: 500;
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .riya-supplier-stats-simple {
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: linear-gradient(135deg, #f8fafc, #ffffff);
          padding: 30px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          flex-wrap: wrap;
          gap: 20px;
        }

        .riya-stat-simple {
          text-align: center;
        }

        .riya-stat-simple .riya-stat-number {
          display: block;
          font-size: 2rem;
          font-weight: 800;
          color: #2563eb;
          line-height: 1.2;
        }

        .riya-stat-simple .riya-stat-label {
          font-size: 0.9rem;
          color: #64748b;
        }

        /* Pricing Section */
        .riya-pricing-section {
          padding: 40px 0 80px;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        }

        .riya-pricing-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .riya-billing-toggle {
          display: inline-flex;
          background: white;
          padding: 4px;
          border-radius: 50px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-top: 20px;
        }

        .riya-toggle-btn {
          border: none;
          padding: 12px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: transparent;
          color: #64748b;
          position: relative;
        }

        .riya-toggle-active {
          background: #2563eb;
          color: white;
        }

        .riya-save-badge {
          background: #fbbf24;
          color: #1e293b;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          margin-left: 8px;
          font-weight: 500;
        }

        .riya-pricing-grid {
          max-width: 1000px;
          margin: 0 auto;
        }

        .riya-pricing-card-enhanced {
          background: white;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .riya-pricing-card-enhanced:hover {
          transform: translateY(-5px);
          box-shadow: 0 30px 60px rgba(37, 99, 235, 0.12);
        }

        .riya-popular-badge {
          position: absolute;
          top: 20px;
          right: 30px;
          background: #2563eb;
          color: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          z-index: 10;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .riya-pricing-card-content {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
        }

        .riya-pricing-left {
          padding: 40px;
          border-right: 1px solid #eef2f6;
        }

        .riya-pricing-emoji {
          font-size: 2.5rem;
          margin-bottom: 15px;
        }

        .riya-pricing-name {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .riya-pricing-description {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 25px;
        }

        .riya-pricing-amount {
          margin-bottom: 25px;
        }

        .riya-currency {
          font-size: 1.2rem;
          font-weight: 600;
          color: #64748b;
          margin-right: 5px;
        }

        .riya-price {
          font-size: 3.5rem;
          font-weight: 800;
          color: #0f172a;
          line-height: 1;
        }

        .riya-pricing-period {
          font-size: 1rem;
          color: #64748b;
          margin-left: 5px;
        }

        .riya-pricing-cta {
          width: 100%;
          border: none;
          padding: 16px;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 30px;
        }

        .riya-pricing-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }

        .riya-quick-setup {
          background: #f8fafc;
          border-radius: 16px;
          padding: 20px;
        }

        .riya-setup-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          color: #0f172a;
        }

        .riya-setup-steps {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .riya-setup-step {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .riya-step-marker {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .riya-step-content {
          display: flex;
          flex-direction: column;
        }

        .riya-step-content strong {
          font-size: 0.95rem;
          margin-bottom: 4px;
        }

        .riya-step-content span {
          font-size: 0.85rem;
          color: #64748b;
        }

        .riya-pricing-right {
          padding: 40px;
          background: #ffffff;
        }

        .riya-features-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .riya-addons-title {
          margin-top: 30px;
        }

        .riya-features-list,
        .riya-addons-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .riya-feature-item,
        .riya-addon-item {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .riya-feature-check,
        .riya-addon-check {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .riya-feature-check i,
        .riya-addon-check i {
          font-size: 14px;
        }

        .riya-feature-item span,
        .riya-addon-item span {
          font-size: 0.95rem;
          color: #334155;
          line-height: 1.5;
        }

        .riya-pricing-footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
        }

        .riya-support-link {
          cursor: pointer;
          font-weight: 500;
        }

        .riya-support-link:hover {
          text-decoration: underline;
        }

        /* Accessibility */
        .riya-clickable:focus-visible {
          outline: 3px solid #2563eb;
          outline-offset: 2px;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .riya-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .riya-services-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .riya-benefits-grid-full {
            grid-template-columns: 1fr;
          }

          .riya-process-steps {
            grid-template-columns: 1fr;
          }

          .riya-logo-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .riya-pricing-card-content {
            grid-template-columns: 1fr;
          }

          .riya-pricing-left {
            border-right: none;
            border-bottom: 1px solid #eef2f6;
          }

          .riya-contact-info {
            flex-direction: column;
            align-items: center;
          }

          .riya-contact-item {
            width: 100%;
            max-width: 400px;
          }
        }

        @media (max-width: 768px) {
          .riya-title {
            font-size: 2.5rem;
          }
          
          .riya-highlight {
            font-size: 3rem;
          }
          
          .riya-tabs {
            gap: 20px;
            overflow-x: auto;
            padding-bottom: 5px;
          }
          
          .riya-tab {
            font-size: 0.95rem;
            white-space: nowrap;
          }
          
          .riya-services-grid {
            grid-template-columns: 1fr;
          }
          
          .riya-section-title {
            font-size: 2rem;
          }

          .riya-features {
            grid-template-columns: 1fr;
          }

          .riya-logo-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .riya-supplier-stats-simple {
            flex-direction: column;
            gap: 20px;
          }

          .riya-contact-section {
            padding: 40px 20px;
          }

          .riya-contact-section h3 {
            font-size: 1.8rem;
          }

          .riya-contact-item {
            padding: 15px 20px;
          }

          .riya-contact-value {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .riya-header {
            padding: 60px 0 30px;
          }

          .riya-logo-grid {
            grid-template-columns: 1fr;
          }

          .riya-pricing-left,
          .riya-pricing-right {
            padding: 25px;
          }

          .riya-price {
            font-size: 2.5rem;
          }

          .riya-billing-toggle {
            flex-direction: column;
            width: 100%;
            border-radius: 12px;
          }

          .riya-toggle-btn {
            width: 100%;
          }

          .riya-contact-item {
            flex-direction: column;
            text-align: center;
          }

          .riya-contact-details {
            align-items: center;
          }
        }
      `}</style>
    </>
  );
};

// Simple Helmet component for meta tags
const Helmet = ({ children }) => {
  return <>{children}</>;
};

export default RiyaTravelSupplierHighlight;